var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.728 6.68804L11.314 5.27404L2 14.588V16.002H3.414L12.728 6.68804ZM14.142 5.27404L15.556 3.86004L14.142 2.44604L12.728 3.86004L14.142 5.27404ZM4.242 18.002H0V13.759L13.435 0.324037C13.6225 0.136566 13.8768 0.03125 14.142 0.03125C14.4072 0.03125 14.6615 0.136566 14.849 0.324037L17.678 3.15304C17.8655 3.34056 17.9708 3.59487 17.9708 3.86004C17.9708 4.1252 17.8655 4.37951 17.678 4.56704L4.243 18.002H4.242Z",
    fill: "#343C46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f2ee5c6a43f2296558ec3614f22c18f2.svg";
export { ForwardRef as ReactComponent };